import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink } from 'react-router-dom';

const ToolbarActions = () => {
  const { t } = useTranslation('invitations');

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button
        color="primary"
        variant="contained"
        component={RouterLink}
        to="/app/invitations/create"
      >
        {t('buttons.invitations_list_create')}
      </Button>
    </Box>
  );
};

export default ToolbarActions;
